import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import {
    FindLoad,
    SendPageSave,
    useGlobalStyles,
    Images,
    useModal,
    DownloadFile,
    FLAGGED_VALUES,
    RolePermission,
    PermissionList,
    getSkipCount,
} from 'utils';
import { CustomDelete, Loader, NoItemsYet, PaginationFillTable, SearchAndFilerFull, SelectActions, TextRow } from 'components';
import { payrollTableInfo, timeSheetTabEnums } from '../constants';
import { staffPayrollActions } from 'store';
import { Resolve } from './resolve';

const UN_PROCESS_ACTION_TYPE = 'UN_PROCESS_PAYROLL';
const BATCH_ACTION_TYPE = 'GET_PROCESSED_PAYROLL_BATCHES';
const ACTION_TYPE = 'GET_PROCESSED_PAYROLL';

export const ProcessPayrollTable = ({}) => {
    const dispatch = useDispatch();
    const globalStyle = useGlobalStyles();
    const { open } = useModal();
    const [page, setPage] = useState(1);
    const [batchPage, setBatchPage] = useState(1);
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const loader = FindLoad(ACTION_TYPE);
    const processed = useSelector((state) => state?.staffPayroll?.processedPayroll);
    const processedBatches = useSelector((state) => state?.staffPayroll?.processedPayrollBatches);
    const list = processed?.batches;
    const [listInfo, setListInfo] = useState(list);
    const [searched, setSearched] = useState({ name: '', text: '' });
    const [expanded, setExpanded] = React.useState(false);
    const [currentId, setCurrentId] = useState(null);
    const [selectedList, setSelectedList] = useState([]);
    const [rowId, setRowId] = useState(null);
    const { loadDownload, downloadBatch } = DownloadFile();
    const loadBatches = FindLoad(BATCH_ACTION_TYPE);

    const renderParams = () => {
        const filteredInfo = {
            ...info,
        };
        filteredInfo.skip = info?.skip ? info?.skip : 0;
        filteredInfo.limit = 50;
        delete filteredInfo.page;
        delete filteredInfo.activeTab;
        delete filteredInfo.staffFull;
        delete filteredInfo.start;
        delete filteredInfo.end;

        info?.start ? (filteredInfo.startDate = info?.start) : delete filteredInfo.startDate;
        info?.end ? (filteredInfo.endDate = info?.end) : delete filteredInfo.endDate;

        if (info?.flag === FLAGGED_VALUES.INCOMPLETE_UNIT) {
            filteredInfo.flag = true;
        } else if (info?.flag === FLAGGED_VALUES.NOT_INCOMPLETE_UNIT) {
            filteredInfo.flag = false;
        } else {
            delete filteredInfo.flag;
        }
        return filteredInfo;
    };

    useEffect(() => {
        if (list && !searched?.value) {
            setListInfo(list);
        }
    }, [list]);

    useEffect(() => {
        if (info?.page) {
            setPage(info?.page);
        }
    }, [info]);

    const changePage = (number) => {
        setPage(number);
        setSearched({ name: '', text: '' });
        SendPageSave(number, info, navigate);
    };

    const getPayrollBatches = (id, loader) => {
        const itemId = id ? id : rowId;
        const _skip = getSkipCount(batchPage, 50);
        dispatch(staffPayrollActions.getProcessedPayrollBatches({ skip: _skip, limit: 50 }, itemId, loader));
    };

    const handleChange = (panel, item) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
        setRowId(isExpanded ? item?.id : null);
        if (isExpanded) {
            getPayrollBatches(item?.id);
        }
    };

    const getDates = (loading) => {
        dispatch(staffPayrollActions.getProcessedPayroll({ ...renderParams() }, loading));
    };

    useEffect(() => {
        getDates();
    }, [info]);

    const download = (e, id) => {
        e.preventDefault();
        e.stopPropagation();
        downloadBatch(id);
        setCurrentId(id);
    };

    const handleOpenResolve = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        open(
            <Resolve
                id={item?.id}
                afterSuccess={getPayrollBatches}
                // afterSuccess={afterSuccess}
                displayId={item?.apptDisplayId}
            />
        );
    };

    const afterSuccess = () => {
        getDates('noLoad');
    };

    const handleCheck = (ev, item, name) => {
        if (name === 'all' || name === 'selectAll') {
            setSelectedList(processed?.batches?.length === selectedList?.length ? [] : processed?.batches?.map((i) => i?.id));
        } else {
            setSelectedList((prev) => (prev?.includes(item?.id) ? prev.filter((id) => id !== item?.id) : [...prev, item?.id]));
        }
    };

    const removeSelectedList = () => {
        setSelectedList([]);
    };

    const afterUnProcess = () => {
        afterSuccess('noLoad');
        removeSelectedList();
    };

    const unProcess = () => {
        open(
            <CustomDelete
                info="Un-process Batch?"
                text="You're about to un-process this batch. This action cannot be undone."
                innerText="Un-process"
                handleDel={() => dispatch(staffPayrollActions.unProcessPayroll(selectedList))}
                afterSuccess={afterUnProcess}
                actionType={UN_PROCESS_ACTION_TYPE}
                body={
                    <div className="deleting-client-info-box" style={{ flexDirection: 'column', alignItems: 'start' }}>
                        <div className="flex-align-start" style={{ gap: 8 }}>
                            <img style={{ marginTop: 4 }} src={Images.fileBlack} alt="icon" />
                            <div>
                                <p style={{ fontWeight: 600 }}>{`${selectedList?.length} timesheets `}</p>
                                <p style={{ fontSize: 12, color: '#475467', fontWeight: 400 }}>
                                    These timesheets will be reset to appointment data.
                                </p>
                            </div>
                        </div>
                    </div>
                }
            />
        );
    };

    const tableInfo = payrollTableInfo(
        download,
        currentId,
        loadDownload,
        handleOpenResolve,
        afterSuccess,
        handleCheck,
        processed?.batches,
        selectedList
    );

    const changeBatchPage = (number) => {
        setBatchPage(number);
        const itemId = rowId ? rowId : processedBatches?.id;
        const _skip = getSkipCount(batchPage, 50);
        dispatch(staffPayrollActions.getProcessedPayrollBatches({ skip: _skip, limit: 50 }, itemId));
    };

    return (
        <div>
            {!!selectedList?.length && (
                <SelectActions
                    selectedList={selectedList?.length}
                    selectAll={handleCheck}
                    selectInnetText={selectedList?.length === processed?.batches?.length ? 'Clear Selection' : 'Select All'}
                    submitText={'Un-process Payroll'}
                    submitBtnIcon={Images.undo}
                    submitClaims={unProcess}
                    removeSelected={removeSelectedList}
                    submitPermission={RolePermission([PermissionList.PAYROLL_MANAGE?.code])}
                />
            )}

            <div className={globalStyle.tableWrapper} style={{margin:'12px 0 0 0'}}>
                <div>
                    <div className="accordion-table-head-wrapper">
                        {tableInfo?.head?.map((i, j) => (
                            <div className="accordion-table-head-row" key={j} style={{ width: i?.width }}>
                                {i?.renderView ? (
                                    <div>{i?.renderView}</div>
                                ) : (
                                    <SearchAndFilerFull
                                        setListInfo={setListInfo}
                                        list={list}
                                        item={i}
                                        page={page}
                                        searched={searched}
                                        setSearched={setSearched}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                    {loader.length ? (
                        <Loader />
                    ) : listInfo?.length ? (
                        <div className="accordion-table-body-wrapper">
                            {listInfo?.map((i, k) => (
                                <React.Fragment key={k}>
                                    <Accordion
                                        style={{ background: expanded === k ? 'rgba(235, 242, 253, 0.50)' : 'white' }}
                                        className={`accordion-wrapper${selectedList?.includes(i?.id) ? ' selected' : ''}`}
                                        expanded={expanded === k}
                                        onChange={handleChange(k, i)}
                                    >
                                        <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
                                            {tableInfo?.body(i)?.map((value, k) => (
                                                <div
                                                    onClick={(e) => {
                                                        if (value?.notClickable) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                        }
                                                    }}
                                                    key={k}
                                                    className="accordion-table-body-row"
                                                    style={{ width: value.width }}
                                                >
                                                    {value?.value}
                                                </div>
                                            ))}
                                            <div className="accordion-up-down">
                                                <img
                                                    className="down-up-icon"
                                                    style={expanded === k ? { transform: 'rotate(-180deg)' } : {}}
                                                    src={Images.dropDown}
                                                    alt="icon"
                                                />
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {loadBatches?.length ? (
                                                <Loader height={'200px'} />
                                            ) : (
                                                <div
                                                    className="accordion-details-wrapper"
                                                    style={{
                                                        minHeight: '200px',
                                                        maxHeight: '500px',
                                                        overflow: 'auto',
                                                        paddingBottom: '10px',
                                                    }}
                                                >
                                                    {!!processedBatches?.timesheets?.length && (
                                                        <div className="accordion-details-head-wrapper">
                                                            {tableInfo?.accordionHead?.map((head, k) => (
                                                                <div
                                                                    key={k}
                                                                    className="accordion-details-head-row"
                                                                    style={{ width: head?.width }}
                                                                >
                                                                    <TextRow name={head?.title} fontWeight={600} />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                    {processedBatches?.timesheets?.length ? (
                                                        processedBatches?.timesheets?.map((item, j) => (
                                                            <div className="accordion-details-body-wrapper" key={j}>
                                                                {tableInfo?.accordionBody(item, j, i)?.map((body, k) => (
                                                                    <div
                                                                        key={k}
                                                                        className="accordion-details-body-row"
                                                                        onClick={(e) => {
                                                                            if (body?.notClickable) {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                            } else {
                                                                                navigate(`/timesheet/${item?.id}`, {
                                                                                    state: { tabType: timeSheetTabEnums.PROCESSED },
                                                                                });
                                                                            }
                                                                        }}
                                                                        style={{ width: body?.width }}
                                                                    >
                                                                        {body?.value}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <NoItemsYet
                                                            text={tableInfo?.noDetailsText}
                                                            containerStyles={{
                                                                padding: '20px 0',
                                                                position: 'relative',
                                                            }}
                                                        />
                                                    )}

                                                    {processedBatches?.count > 50 && (
                                                        <PaginationFillTable
                                                            listLength={processedBatches?.timesheets?.length}
                                                            page={batchPage}
                                                            handleReturn={(number) => changeBatchPage(number)}
                                                            count={processedBatches?.count}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </AccordionDetails>
                                    </Accordion>
                                </React.Fragment>
                            ))}
                        </div>
                    ) : (
                        <div style={{ position: 'relative' }}>
                            <NoItemsYet text={tableInfo.notYet.title} subTitle={tableInfo.notYet.subTitle} image={tableInfo.notYet.image} />
                        </div>
                    )}
                    {processed?.count > 0 && (
                        <div style={{ height: '76px' }}>
                            <PaginationFillTable
                                listLength={listInfo?.length}
                                page={page}
                                handleReturn={(number) => changePage(number)}
                                count={processed?.count}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
